import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        // Role chosen before the Google redirect (e.g. /auth/callback?role=contractor)
        const desiredRole = new URLSearchParams(window.location.search).get('role');

        if (!sessionId) {
          console.error('No session_id in URL');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId, desired_role: desiredRole }),
        });

        if (!response.ok) {
          throw new Error('Authentication failed');
        }

        const data = await response.json();

        // Store JWT token for API calls
        if (data.token) {
          localStorage.setItem('token', data.token);
        }

        // Store user data
        if (data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
          localStorage.setItem('userType', data.user.user_type);
          localStorage.setItem('userId', data.user._id);
        }

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect to appropriate dashboard based on user type
        const userType = data.user?.user_type;
        if (userType === 'contractor') {
          navigate('/contractor-dashboard', { replace: true, state: { user: data.user } });
        } else if (userType === 'admin') {
          navigate('/admin', { replace: true, state: { user: data.user } });
        } else if (userType === 'homeowner') {
          navigate('/homeowner-dashboard', { replace: true, state: { user: data.user } });
        } else {
          navigate('/worker-dashboard', { replace: true, state: { user: data.user } });
        }

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-blue-600 animate-spin mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Signing you in...</h2>
        <p className="text-gray-500">Please wait while we complete authentication</p>
      </div>
    </div>
  );
};

export default AuthCallback;
